import styled from "styled-components";

export const Spinner = styled.div<{ width; height; color; border }>`
  &.spinnerLoader {
    border: 5px solid #f3f3f3;
    border: ${({ color, border }) => `${border}px solid ${color}`};
    animation: spin 1s linear infinite;
    border-top: 5px solid #555;
    border-radius: 50%;
    width: ${({ width }) => width + "px"};
    height: ${({ height }) => height + "px !important"};
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
